import { render, staticRenderFns } from "./CameraPlayerControl.vue?vue&type=template&id=b84a5cb0&"
import script from "./CameraPlayerControl.vue?vue&type=script&lang=js&"
export * from "./CameraPlayerControl.vue?vue&type=script&lang=js&"
import style0 from "./CameraPlayerControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports